const initialState = {
  sections: {},
  byEducation: false,
  filterText: 'по учебному заведению',
  participants: {
    byLastName: {},
    byEducation: {},
    counts: {
      all: 0
    },
    sections: []
  }
};


export default (state = initialState, action) => {
  switch (action.type) {
    case 'PARSE_PARTICIPANTS_LIST':
      return {
        ...state,
        sections: action.sections,
        participants: action.participants
      };
    case 'CHECKOUT_FILTER':
      return {
        ...state,
        byEducation: !state.byEducation,
        filterText: !state.byEducation ? 'по фамилии' : 'по учебному заведению'
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/participants-page/reducers.js